import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropKickVods(slug?: string) {
    return useQuery({
        queryKey: ["drop-kick-vods", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentKickVods({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 15 * 60 * 1000,
    });
}
